import axios from 'axios'
import { config } from "../Config/config"

const alamatRService = {
    getAll: () => {
        const result = axios.get(config.apiUrl + '/alamatRS')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },

    getAllRS: () => {
        const result = axios.get(config.apiUrl + '/daerah')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    

}

export default alamatRService